import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import apiClient from '../../Api/apiClient';

const EditTenderPaymentMessage = () => {
  const [countdown, setCountdown] = useState(15);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState([]);
  const [status, setStatus] = useState('');
  const searchParams = new URLSearchParams(location.search);
  const order_id = searchParams.get('order_id');
  const userType = localStorage.getItem('user_type');

  useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        let url = `/user/payment/editmytender/return-url?order_id=${order_id}`;
        if (userType === 'affiliator') {
          url = `/affiliator/payment/editmytender/return-url?order_id=${order_id}`;
        }
        const response = await apiClient.get(url);
        setResponse(response.data);
        setStatus(response.data.verificationResponse[0].sp_massage);
      } catch (err) {
        setError('Failed to fetch invoice data');
        console.error(err);
      } finally {
        setLoading(false); // Mark loading as finished
      }
    };
    fetchInvoiceData();
  }, [order_id]);

  useEffect(() => {
    if (!loading) {
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev === 0) {
            clearInterval(timer);
            navigate('/editMyTender');
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer); // Cleanup function
    }
  }, [loading, navigate]);

  return (
    <div className="flex flex-col items-center justify-center py-10 md:mt-32 mt-32 2xl:mt-36 bg-white text-gray-900 md:text-sm text-xs px-2">
      <div className="text-center max-w-md w-full shadow-lg rounded-lg border-gray-200 bg-gray-300 md:p-6 p-4">
        {loading ? (
          <div className="flex justify-center items-center py-10">
            <span className="text-lg font-semibold text-gray-700">
              Loading...
            </span>
          </div>
        ) : (
          <>
            {/* Success Icon */}
            <div className="mt-4 flex items-center justify-center bg-green-100 rounded-full w-16 h-16 mx-auto mb-6">
              <div className="bg-green-100 p-4 rounded-full">
                <svg
                  className="md:w-14 md:h-14 w-12 h-12 text-publishTenderBtn"
                  fill="none"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="2"
                    className="animate-pulse"
                  />
                  <path
                    d="M8 14s1.5 2 4 2 4-2 4-2"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="animate-draw"
                  />
                  <circle
                    cx="9"
                    cy="9"
                    r="1"
                    fill="currentColor"
                    className="animate-blink"
                  />
                  <circle
                    cx="15"
                    cy="9"
                    r="1"
                    fill="currentColor"
                    className="animate-blink"
                  />
                </svg>
              </div>
            </div>

            {/* Countdown Timer */}
            <span className="font-semibold text-lg text-publishTenderBtn">
              {countdown}
            </span>

            {/* Title */}
            <h1 className="md:text-xl text-lg font-bold text-gray-700 mb-4">
              {response.message}
            </h1>

            {/* Countdown Progress Bar */}
            <div className="w-full bg-gray-300 rounded-full h-2 mb-6">
              <div
                className="bg-publishTenderBtn h-1.5 rounded-full transition-all"
                style={{ width: `${(countdown / 15) * 100}%` }}
              ></div>
            </div>

            {/* Manual Redirect Button */}
            <button
              onClick={() => navigate('/editMyTender')}
              className="w-full bg-publishTenderBtn text-white py-3 rounded-lg font-medium hover:bg-seviceBghover hover:text-blue-800 transition shadow-md"
            >
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EditTenderPaymentMessage;

// import React, { useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import apiClient from '../../../Api/apiClient';
// const EditTenderPaymentMessage = () => {
//     const [countdown, setCountdown] = useState(15); // Set initial countdown time
//     const navigate = useNavigate();
//     const location = useLocation();
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [response, setResponse] = useState([]);
//     const [status, setStatus] = useState('');
//     const searchParams = new URLSearchParams(location.search);
//     const order_id = searchParams.get('order_id');
//     console.log(order_id)
//     const userType = localStorage.getItem('user_type');
//     useEffect(() => {
//         const fetchInvoiceData = async () => {
//             try {
//                 let url = `/user/payment/editmytender/return-url?order_id=${order_id}`;
//                 if (userType==='affiliator') {
//                     url = `/affiliator/payment/editmytender/return-url?order_id=${order_id}`;
//                 }
//                 // console.log('url:', url);
//                 const response = await apiClient.get(url);
//                 // console.log('payment response:', response);
//                 setResponse(response.data)
//                 setStatus(response.data.verificationResponse[0].sp_massage)
//             } catch (err) {
//                 setError('Failed to fetch invoice data');
//                 console.error(err);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchInvoiceData();
//     }, [order_id]);
//     useEffect(() => {
//         if (countdown === 0) {
//             navigate('/editMyTender');
//         }
//         const timer = setInterval(() => {
//             setCountdown(prev => {
//                 if (prev === 0) {
//                     clearInterval(timer);
//                     return 0;
//                 }
//                 return prev - 1;
//             });
//         }, 1000);
//         return () => clearInterval(timer); // Cleanup function
//     }, [countdown, status, navigate]);
//     return (
//       <div className="flex flex-col items-center justify-center py-10 md:mt-32 mt-32 2xl:mt-36 bg-white text-gray-900  md:text-sm text-xs px-2">
//         <div className="text-center max-w-md w-full shadow-lg rounded-lg border-gray-200 bg-gray-300 md:p-6 p-4 ">
//           {/* Success Icon */}
//           <div className="mt-4 flex items-center justify-center bg-green-100 rounded-full w-16 h-16 mx-auto mb-6">
//             <div className="flex justify-center items-center mb-4">
//               <div className="bg-green-100 p-4 rounded-full">
//                 <svg
//                   className="md:w-14 md:h-14 w-12 h-12 text-publishTenderBtn"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   {/* Face Circle */}
//                   <circle
//                     cx="12"
//                     cy="12"
//                     r="10"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     className="animate-pulse"
//                   />
//                   {/* Smile Curve */}
//                   <path
//                     d="M8 14s1.5 2 4 2 4-2 4-2"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     className="animate-draw"
//                   />
//                   {/* Left Eye */}
//                   <circle
//                     cx="9"
//                     cy="9"
//                     r="1"
//                     fill="currentColor"
//                     className="animate-blink"
//                   />
//                   {/* Right Eye */}
//                   <circle
//                     cx="15"
//                     cy="9"
//                     r="1"
//                     fill="currentColor"
//                     className="animate-blink"
//                   />
//                 </svg>
//               </div>
//             </div>
//           </div>
//           <span className="font-semibold text-lg text-publishTenderBtn">
//             {countdown}
//           </span>{' '}
//           {/* Title */}
//           <h1 className="md:text-xl text-lg font-bold text-gray-700 mb-4">
//             {response.message}
//           </h1>
//           {/* Countdown Progress Bar */}
//           <div className="w-full bg-gray-300 rounded-full h-2 mb-6">
//             <div
//               className="bg-publishTenderBtn h-1.5 rounded-full transition-all"
//               style={{ width: `${(countdown / 15) * 100}%` }}
//             ></div>
//           </div>
//           {/* Manual Redirect Button */}
//           <button
//             onClick={() => navigate('/editMyTender')}
//             className="w-full bg-publishTenderBtn text-white py-3 rounded-lg font-medium hover:bg-seviceBghover hover:text-blue-800 transition shadow-md"
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     );
// };
// export default EditTenderPaymentMessage;
